import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ArrowBackIcon, Box, Stack, Typography } from '@esgian/esgianui';
import { useSelector } from 'react-redux';
import { getSideMenuOpen } from '@store/features';
import { getMainPageSlice } from '@store/features/filters/MainPageSlice/MainPageSlice';
import moment from 'moment/moment';
import { DATE_MONTH_READABLE_FORMAT } from '@constants/index';
import { ArrowBackButton } from '@components';
import { useNavigate } from 'react-router-dom';
import { getSelectedBaseline } from '@store/features/filters/BaselineComparisonSlice/BaselineComparisonSlice';
import UnitDisplaySelect from '@components/Inputs/UnitDisplaySelect';

function BaselineCompStickyHeader({ backUri }) {
  const [isSticky, setIsSticky] = useState(false);
  const sideMenuOpen = useSelector(getSideMenuOpen);
  const { selectedRig, startDate, endDate } = useSelector(getMainPageSlice);
  const selectedBaseline = useSelector(getSelectedBaseline);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 140) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  let sideMenuSize = sideMenuOpen ? 264 : 56;

  const getDatesReadable = (start, end) => {
    return `${moment.utc(start).format(DATE_MONTH_READABLE_FORMAT)} - ${moment
      .utc(end)
      .format(DATE_MONTH_READABLE_FORMAT)}`;
  };

  return (
    <Box
      id={'header-sticky'}
      sx={{
        width: `calc(100% - ${sideMenuSize}px)`,
        position: 'fixed',
        top: 0,
        left: `${sideMenuSize}px)`,
        right: 0,
        backgroundColor: ({ palette }) => palette.background.default,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        transition: 'transform 0.3s ease-in-out',
        borderBottom: ({ palette }) => `1px solid ${palette.neutral.neutral01}`,
        transform: `translateY(${isSticky ? 0 : '-100%'})`,
        zIndex: 100
      }}>
      <Stack sx={{ p: 2, alignItems: 'center' }} spacing={5} direction={'row'}>
        <Stack spacing={2} direction={'row'} sx={{ alignItems: 'center' }}>
          <ArrowBackButton onClick={() => navigate(backUri)}>
            <ArrowBackIcon color={'inherit'} fontSize={'small'} />
          </ArrowBackButton>
          <Typography
            variant={'body1'}
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              window.scrollTo(0, 0);
            }}>
            {`${selectedRig?.rigName}, ${getDatesReadable(startDate, endDate)}`}
          </Typography>
        </Stack>

        <Typography variant={'caption'}>COMPARE TO</Typography>
        <Typography
          variant={'body1'}
          sx={{ cursor: 'pointer' }}
          onClick={() => {
            window.scrollTo(0, 0);
          }}>{`${selectedBaseline?.baselineName}`}</Typography>
        <UnitDisplaySelect />
      </Stack>
    </Box>
  );
}

BaselineCompStickyHeader.propTypes = {
  backUri: PropTypes.string
};

BaselineCompStickyHeader.defaultProps = {
  backUri: ''
};

export default BaselineCompStickyHeader;
